import React from "react";
import { RecordContextProvider } from "react-admin";
import { Box, Button } from "@mui/material";
import ReplyIcon from "@mui/icons-material/Reply";
import SendIcon from "@mui/icons-material/Send";
import BusinessTripInfoSection from "components/StaffRequests/DetailsStaffRequest/InfoSections/BusinessTripInfoSection";
import { StaffRequestTypes } from "utils/constants";

const BusinessTripRequestPreview = ({ data, onBack, onConfirm }) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
    <RecordContextProvider value={data}>
      <BusinessTripInfoSection type={StaffRequestTypes.BusinessTrip} />
      <Box sx={{ display: "flex", gap: 2, mt: 2, ml: 4 }}>
        <Button
          variant="contained"
          color="error"
          onClick={onBack}
        >
          <ReplyIcon /> Назад
        </Button>
        <Button
          variant="contained"
          color="success"
          startIcon={<SendIcon />}
          onClick={onConfirm}
        >
          Заяви командировка
        </Button>
      </Box>
    </RecordContextProvider>
  </Box>
);

export default BusinessTripRequestPreview;
